/**
 * Private modules
 */
const {
  amount,
  customerId,
  objectId,
  rootId,
} = require('../.private').components;

module.exports = {
  updateCustomerRunnerContractPayoutsByRootId: {
    properties: {
      body: {
        properties: {
          payouts: {
            items: {
              properties: {
                amount,
                objectId,
              },
              required: [
                'amount',
                'objectId',
              ],
              type: 'object',
            },
            minItems: 1,
            type: 'array',
            uniqueItems: true,
          },
        },
        required: ['payouts'],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          rootId,
        },
        required: [
          'customerId',
          'rootId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
};
